import styled from 'styled-components';

export const FlexWrapper = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;

  img,
  svg {
    height: 3rem;
    width: 3rem;
  }
`;
